import { BasicDetailedUserFragment } from "./queries.graphql";
import useBasicData from "./useBasicData";

/**
 * A variant of useBasicData that asserts user is non-null.
 * Use this in contexts where a user is guaranteed to exist (e.g., authenticated routes).
 * Throws an error if user is null, indicating a programming error.
 */
export const useRequiredUser = (): Omit<
  ReturnType<typeof useBasicData>,
  "user"
> & { user: BasicDetailedUserFragment } => {
  const { user, ...rest } = useBasicData();

  if (!user) {
    throw new Error(
      "useRequiredUser must be used within an authenticated context",
    );
  }

  return { user, ...rest };
};
